module.exports = __webpack_public_path__ + "img/cl-install-DMF-13-test_12200.2c99341d.png";